import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

const FADE_DURATION = 300;

const ConfirmationAlert = ({ title, message, onConfirm, onCancel }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const handleClose = (action) => {
    setVisible(false);
    setTimeout(() => {
      if (action === "confirm") onConfirm();
      else onCancel();
    }, FADE_DURATION);
  };

  //  Define modalContent before returning
  const modalContent = (
    <div
      style={{
        ...styles.overlay,
        opacity: visible ? 1 : 0,
        transition: `opacity ${FADE_DURATION}ms ease-in-out`,
      }}
    >
      <div style={styles.modal} className="text-center">
        <p style={styles.message}>{message || "Do you want to proceed?"}</p>
        <div style={styles.buttons}>
          <button onClick={() => handleClose("cancel")} style={styles.cancelBtn}>
            Cancel
          </button>
          <button onClick={() => handleClose("confirm")} style={styles.confirmBtn}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );

  // Use React portal to render outside .app-wrapper
  return ReactDOM.createPortal(modalContent, document.body);
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "8px",
    minWidth: "300px",
    boxShadow: "0 0 10px rgba(0,0,0,0.25)",
    color: "black",
  },
  message: { marginBottom: "20px" },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  cancelBtn: {
    padding: "6px 12px",
    backgroundColor: "#ccc",
    border: "none",
    cursor: "pointer",
    borderRadius: "4px",
  },
  confirmBtn: {
    padding: "6px 12px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    borderRadius: "4px",
  },
};

export default ConfirmationAlert;
